'use client';

import { MDXError } from './mdx-error';

type MDXStyleProps = React.HTMLAttributes<HTMLStyleElement> & {
  hasLitePlus: boolean;
};

export function MDXStyle({ hasLitePlus, ...props }: MDXStyleProps) {
  if (!hasLitePlus) {
    return (
      <MDXError
        title="Lite+ Plan Required"
        description={
          <>
            Please upgrade your account to use style tags if you manage this
            site.
          </>
        }
        cta={{
          label: 'Upgrade',
          href: 'https://app.quotion.co/billing',
        }}
      />
    );
  }
  return <style {...props} />;
}
